import { API_BASE_URL, SOCKETURL, PFR_API_URL, COOKIE_DOMAIN } from "./site_urls";

export const APPLICATION_NAME = "Rodeo Picks";
export const APPLICATION_GLOBAL_SLUG = "rodeo-pick";
export const APPLICATION_VERSION = "1.0.1";
export const SSO_COOKIE = "TRT_AUTH_TOKEN";
export { COOKIE_DOMAIN };
export const STORAGE = "RODEO-APP";
export const SELECTED_EVENT_STORAGE = `${APPLICATION_NAME}-Event`;
export const PAGE_TITLE = `${APPLICATION_NAME} - `;
export const INSIDERODEO_EVENT_STORAGE = `EXTERNAL-EVENT-FOR-RODEOPICK`;
export const MARKETING_SITE_URL = "https://games.insiderodeo.com/";
export const RODEPICK_NEXT_GAME_IDS = `${APPLICATION_NAME}-NEXT-GAMES`;
export const SOCKET_TRANSPORTS = ["websocket", "polling"]; // WebSocket-first, polling fallback
export const MAINTENANCE_MODE = false;
export const IS_SHOWING_ADD_TO_HOME_SCREEN_IOS = `${APPLICATION_NAME}-IOS`;

export const PER_PAGE = 50;
export const WITHOUT_PER_PAGE = 99999;

export const FILE_BASE_PATH = "";
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_STAGE = process.env.REACT_APP_STAGE;

export const DATE_FORMAT = "MM/dd/yyyy";

export const DATE_ALL_FORMAT = {
  DATE_PICKER_FORMAT: "MM/dd/yyyy",
  MOMENT_FORMAT: "MM/DD/yyyy",
};

export const CHAT_DATE_TIME_FORMAT = {
  DISPLAY_DATE_WITH_TIME: "Do MMMM, YYYY hh:mm a",
  DISPLAY_DAY_TIME: "dddd hh:mm a",
};
export const TIME_CONFIG = {
  TIME_FORMAT: "hh:mm a",
  TIME_INTERVALS: 5,
};

export const SOCKET_URL = SOCKETURL;

//#region URLS section

export const URLS = {
  HOME: "/",
  CMS: {
    CMS: "/cms/:slug",
  },
  AUTH: {
    REGISTRATION: "/registration",
    LOGIN: "/login",
    LOGIN_WITH_EMAIL: "/login-with-email",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password/:token",
    MY_PROFILE: "/my-profile",
    AUTO_LOGIN: "/autologin/:token",
  },
  EVENT: {
    RODEO_DETAILS_LISTING: "/rodeodetails",
    LEADERBOARD: "/leaderboard/:rodeoEventId?/:performanceId?",
    LINK_LEADERBOARD: "/leaderboard",
    GROUPS: "/groups",
    RODEO_EVENTS: "/rodeo-events/:groupId?",
    NOGRP_RODEO_EVENTS: "/rodeo-events",
    PAST_RODEO_EVENTS: "/past-rodeo-events",
    UPCOMING_EVENTS: "/upcoming-events",
    PERFORMANCES: "/performances/:rodeoEventId",
    EVENTS: "/events/:rodeoEventId/:performanceId",
    RIDERS: "/riders/:rodeoEventId/:performanceId/:eventId",
    PRIZES: "/prizes/:rodeoEventId/:performanceId",
    PRIZE_DETAILS: "/prize/:rodeoEventId/:performanceId/:type",
    MOST_POPULAR_PICKS: "/most-popular-picks/:rodeoEventId/:performanceId/:eventId",
    MY_TEAM: "/my-team/:rodeoEventId",
    WINNING_TICKET: "/winning-ticket",
    TEAM_IMAGE: "/team/:imageName",
    LEADER_BOARD: {
      RODEO_EVENT: "/result/:rodeoEventId/:performanceId?",
      GROUP: "/group-result/:groupId",
    },
    LEAGUE: "/league/:performanceId/:code",
    VS_LEAGUE: "/league/:code",
    TV_IMAGE: "/tv-leaderboard/:gameId",
    GROUP_TV_IMAGE: "/group-tv-leaderboard/:groupId",
  },
};

//#region API_URLS section

export const API_URL = {
  GAME_DETAILS: `${API_BASE_URL}game-details/`,
  CMS: {
    GET_CMS: `${API_BASE_URL}get-cms-list-details`,
    GET_BLOCKS: `${API_BASE_URL}blocks`,
    GET_LIVE_PERFORMANCE: `${API_BASE_URL}rodeo-pick/rodeo-event/live-performance`,
  },
  COMMON: {
    COUNTRIES: `${PFR_API_URL}common/get-countries`,
    STATES: `${PFR_API_URL}common/get-states`,
    CITIES: `${PFR_API_URL}common/get-cities`,
    NEWSLETTER_SIGNUP: `${PFR_API_URL}newsletter/signup`,
    GET_GAME_STATUS_TEXT: `${API_BASE_URL}get-game-status-text`,
  },
  AUTH: {
    REGISTRATION: `${API_BASE_URL}register`,
    LOGIN: `${API_BASE_URL}login`,
    LOGIN_WITH_OTP: `${API_BASE_URL}login-with-otp`,
    LOGIN_WITH_EMAIL: `${API_BASE_URL}login-with-email`,
    FORGOT_PASSWORD: `${API_BASE_URL}password/email`,
    RESET_PASSWORD: `${API_BASE_URL}reset-password`,
    LOGOUT: `${API_BASE_URL}auth/logout`,
    DETAILS: `${API_BASE_URL}init`,
    UPDATE_PROFILE: `${API_BASE_URL}users/update`,
    UPDATE_DISPLAY_NAME: `${API_BASE_URL}users/update-display-name`,
    UPDATE_DOB: `${API_BASE_URL}users/update-dob`,
    UPDATE_EMAIL: `${API_BASE_URL}users/update-email`,
    CHECK_VALID_TOKEN: `${API_BASE_URL}check-valid-token`,
    SAVE_NOTIFICATION: `${API_BASE_URL}inside-rodeo/save-notification`,
    CREATE_UPDATE_USER_GAME: `${API_BASE_URL}create-update-user-game`,
    REGISTRATION_FIELDS: `${API_BASE_URL}registration-fields`,
    AUTO_LOGIN: `${API_BASE_URL}auto-login-with-token`,
    SAVE_USER_PICKS: `${API_BASE_URL}rodeo-pick/save-user-picks`,
    SSO_CHECK: `${PFR_API_URL}login/sso-check`,
  },
  EVENT: {
    GROUPS: `${API_BASE_URL}rodeo-pick/rodeo-event-groups`,
    RODEO_EVENTS: `${API_BASE_URL}rodeo-pick/rodeo-event/`,
    PAST_RODEO_EVENTS: `${API_BASE_URL}rodeo-pick/past-rodeo-events`,
    UPCOMING_EVENTS: `${API_BASE_URL}rodeo-pick/upcoming-rodeos`,
    PERFORMANCES: `${API_BASE_URL}rodeo-pick/performances/`,
    EVENTS: `${API_BASE_URL}rodeo-pick/events/`,
    RODEO_EVENT_EVENTS: `${API_BASE_URL}rodeo-pick/rodeo-event/events`,
    RODEO_EVENT_USER_PICK: `${API_BASE_URL}rodeo-pick/rodeo-event/user-pick`,
    RODEO_EVENT_YOUR_PICKS: `${API_BASE_URL}rodeo-pick/rodeo-event/your-picks`,
    PICK_RIDER: `${API_BASE_URL}rodeo-pick/user-pick`,
    GAME_STATUS_TEXT: `${API_BASE_URL}get-game-status-text`,
    YOUR_PICKS: `${API_BASE_URL}rodeo-pick/your-picks/`,
    MY_TEAM: `${API_BASE_URL}rodeo-pick/my-teams/`,
    MY_CORRECT_PICKS: `${API_BASE_URL}rodeo-pick/my-correct-picks/`,
    APPLY_LEAGUE_CODE: `${API_BASE_URL}rodeo-pick/apply-league-code`,
    GET_SHARE_IMAGE_LINK: `${API_BASE_URL}rodeo-pick/rodeo-event/create-share-image-link`,
    MOST_POPULAR_PICKS: `${API_BASE_URL}rodeo-pick/most-popular-picks`,
    GROUP_LEADER_BOARD: `${API_BASE_URL}rodeo-pick/group-leaderboard/`,
    LEADERBOARD: `${API_BASE_URL}rodeo-pick/leaderboard`,
    LEAGUE_LEADERBOARD: `${API_BASE_URL}rodeo-pick/league-leaderboard/`,
    VS_LEAGUE_LEADERBOARD: `${API_BASE_URL}rodeo-pick/league-relation-leaderboard/`,
    TV_IMAGE: `${API_BASE_URL}rodeo-pick/leaderboard-tvimage`,
    GROUP_TV_IMAGE_DETAILS: `${API_BASE_URL}rodeo-pick/group-leaderboard-tvimage`,
    ACTIVE_PERFORMANCES: `${API_BASE_URL}rodeo-pick/rodeo-event/active-performances`,
    CATEGORIZED_PERFORMANCES: `${API_BASE_URL}rodeo-pick/rodeo-event/categorized-performances`,
    CATEGORIZED_RODEO_EVENTS: `${API_BASE_URL}rodeo-pick/rodeo-event/categorized-rodeo-events`,
    CATEGORIZED_EVENT_GROUPS: `${API_BASE_URL}rodeo-pick/event-groups/categorized-event-groups`,
    EVENT_GROUPS_LEADERBOARD: `${API_BASE_URL}rodeo-pick/event-groups/leaderboard`,
    RODEO_LEADERBOARD: `${API_BASE_URL}rodeo-pick/rodeo-event/rodeo-leaderboard`,
    PERFORMANCE_LEADERBOARD: `${API_BASE_URL}rodeo-pick/rodeo-event/performance-leaderboard`,
    MY_PICK_LIST: `${API_BASE_URL}rodeo-pick/rodeo-event/my-pick-list`,
    SAVE_COUPON: `${API_BASE_URL}rodeo-pick/rodeo-event/save-coupon`,
    WINNING_TICKET_RESULTS: `${API_BASE_URL}rodeo-pick/rodeo-event/winning-ticket-results`,
  },
};

//#region ACTIONS section

export const ACTIONS = {
  COMMON: {
    SETTINGS: "ACTIONS/COMMON/SETTINGS",
    SEO_LIST: "ACTIONS/COMMON/SEO_LIST",
    GET_GAME_STATUS_TEXT: "ACTIONS/COMMON/GET_GAME_STATUS_TEXT",
  },
  CMS: {
    GET_BLOCKS: "ACTIONS/CMS/GET_BLOCKS",
  },
  LOADER: {
    SET_FP_STATUS: "ACTIONS/LOADER/SET_FP_STATUS",
  },
  AUTH: {
    LOGIN: "ACTIONS/USER/LOGIN",
    LOGIN_WITH_OTP: "ACTIONS/USER/LOGIN_WITH_OTP",
    ME: "ACTIONS/USER/ME",
    ONLINE_STATUS_CHANGE: "ACTIONS/USER/ONLINE_STATUS_CHANGE",
    SOCKET_INSTANCE_CONTAINER: "ACTIONS/USER/SOCKET_INSTANCE_CONTAINER",
    LOGOUT: "ACTIONS/USER/LOGOUT",
    PROFILE: "ACTIONS/USER/PROFILE",
    GUEST_USER_ID: "ACTIONS/USER/GUEST_USER_ID",
    RESET_GUEST_USER_ID: "ACTIONS/USER/RESET_GUEST_USER_ID",
    UPDATE_DISPLAY_NAME: "ACTIONS/USER/UPDATE_DISPLAY_NAME",
    UPDATE_DOB: "ACTIONS/USER/UPDATE_DOB",
    UPDATE_EMAIL: "ACTIONS/USER/UPDATE_EMAIL",
    SET_GUEST_USER_ID: "ACTIONS/USER/SET_GUEST_USER_ID",
    SET_PICK_IDS: "ACTIONS/USER/SET_PICK_IDS",
  },
  EVENT: {
    RESET_PICK_ID: "ACTIONS/EVENT/RESET_PICK_ID",
    GAME_DETAILS: "ACTIONS/EVENT/GAME_DETAILS",
    GROUPS: "ACTIONS/EVENT/GROUPS",
    RODEO_EVENTS: "ACTIONS/EVENT/RODEO_EVENTS",
    PAST_RODEO_EVENTS: "ACTIONS/EVENT/PAST_RODEO_EVENTS",
    RODEO_EVENT_DETAILS: "ACTIONS/EVENT/RODEO_EVENT_DETAILS",
    PERFORMANCES: "ACTIONS/EVENT/PERFORMANCES",
    PERFORMANCE_DETAILS: "ACTIONS/EVENT/PERFORMANCE_DETAILS",
    EVENTS: "ACTIONS/EVENT/EVENTS",
    RODEO_EVENT_EVENTS: "ACTIONS/EVENT/RODEO_EVENT_EVENTS",
    RODEO_EVENT_USER_PICK: "ACTIONS/EVENT/RODEO_EVENT_USER_PICK",
    RODEO_EVENT_YOUR_PICKS: "ACTIONS/EVENT/RODEO_EVENT_YOUR_PICKS",
    UPDATE_RIDER_PICK_STATUS: "ACTIONS/EVENT/UPDATE_RIDER_PICK_STATUS",
    EVENT_DETAILS: "ACTIONS/EVENT/EVENT_DETAILS",
    RIDERS: "ACTIONS/EVENT/RIDERS",
    GAME_STATUS_TEXT: "ACTIONS/EVENT/GAME_STATUS_TEXT",
    RODEO_EVENT_STATUS_TEXT: "ACTIONS/EVENT/RODEO_EVENT_STATUS_TEXT",
    RODEO_EVENT_GLOW: "ACTIONS/EVENT/RODEO_EVENT_GLOW",
    EVENT_STATUS_UPDATE: "ACTIONS/EVENT/EVENT_STATUS_UPDATE",
    PERFORMANCE_END_ALL_EVENTS: "ACTIONS/EVENT/PERFORMANCE_END_ALL_EVENTS",
    PERFORMANCE_START_PICK: "ACTIONS/EVENT/PERFORMANCE_START_PICK",
    WINNER_DECLARED: "ACTIONS/EVENT/WINNER_DECLARED",
    GROUP_EVENT_GLOW: "ACTIONS/EVENT/GROUP_EVENT_GLOW",
    APPLY_LEAGUE_CODE: "ACTIONS/EVENT/APPLY_LEAGUE_CODE",
    STATUS_MSG: "ACTIONS/EVENT/STATUS_MSG",
    ACTIVE_PERFORMANCES: "ACTIONS/EVENT/ACTIVE_PERFORMANCES",
    CATEGORIZED_PERFORMANCES: "ACTIONS/EVENT/CATEGORIZED_PERFORMANCES",
    CATEGORIZED_RODEO_EVENTS: "ACTIONS/EVENT/CATEGORIZED_RODEO_EVENTS",
    CATEGORIZED_EVENT_GROUPS: "ACTIONS/EVENT/CATEGORIZED_EVENT_GROUPS",
    EVENT_GROUPS_LEADERBOARD: "ACTIONS/EVENT/EVENT_GROUPS_LEADERBOARD",
    RODEO_LEADERBOARD: "ACTIONS/EVENT/RODEO_LEADERBOARD",
    PERFORMANCE_LEADERBOARD: "ACTIONS/EVENT/PERFORMANCE_LEADERBOARD",
    SIDEBAR_PERFORMANCE_LEADERBOARD: "ACTIONS/EVENT/SIDEBAR_PERFORMANCE_LEADERBOARD",
    SIDEBAR_RODEO_LEADERBOARD: "ACTIONS/EVENT/SIDEBAR_RODEO_LEADERBOARD",
    SIDEBAR_EVENT_GROUPS_LEADERBOARD: "ACTIONS/EVENT/SIDEBAR_EVENT_GROUPS_LEADERBOARD",
    MY_PICK_LIST: "ACTIONS/EVENT/MY_PICK_LIST",
    TV_IMAGE: "ACTIONS/EVENT/TV_IMAGE",
    START_STOP_RP_EVENT: "ACTIONS/EVENT/START_STOP_RP_EVENT",
  },
};

//#region SAGA_ACTIONS section

export const SAGA_ACTIONS = {
  GAME_DETAILS: "SAGA_ACTIONS/GAME_DETAILS",
  CMS: {
    GET_CMS: "SAGA_ACTIONS/COMMON/GET_CMS",
    GET_BLOCKS: "SAGA_ACTIONS/COMMON/GET_BLOCKS",
    GET_LIVE_PERFORMANCE: "SAGA_ACTIONS/CMS/GET_LIVE_PERFORMANCE",
  },
  COMMON: {
    COUNTRIES: "SAGA_ACTIONS/COMMON/COUNTRIES",
    STATES: "SAGA_ACTIONS/COMMON/STATES",
    CITIES: "SAGA_ACTIONS/COMMON/CITIES",
    NEWSLETTER_SIGNUP: "SAGA_ACTIONS/COMMON/NEWSLETTER_SIGNUP",
    GET_GAME_STATUS_TEXT: "SAGA_ACTIONS/COMMON/GET_GAME_STATUS_TEXT",
  },
  AUTH: {
    LOGIN: "SAGA_ACTIONS/AUTH/LOGIN",
    LOGIN_WITH_OTP: "SAGA_ACTIONS/AUTH/LOGIN_WITH_OTP",
    LOGIN_WITH_EMAIL: "SAGA_ACTIONS/AUTH/LOGIN_WITH_EMAIL",
    REGISTRATION: "SAGA_ACTIONS/AUTH/REGISTRATION",
    FORGOT_PASSWORD: "SAGA_ACTIONS/AUTH/FORGOT_PASSWORD",
    RESET_PASSWORD: "SAGA_ACTIONS/AUTH/RESET_PASSWORD",
    LOGOUT: "SAGA_ACTIONS/AUTH/LOGOUT",
    DETAILS: "SAGA_ACTIONS/AUTH/DETAILS",
    UPDATE_PROFILE: "SAGA_ACTIONS/AUTH/UPDATE_PROFILE",
    AUTO_LOGIN: "SAGA_ACTIONS/AUTH/AUTO_LOGIN",
    UPDATE_DISPLAY_NAME: "SAGA_ACTIONS/AUTH/UPDATE_DISPLAY_NAME",
    UPDATE_DOB: "SAGA_ACTIONS/AUTH/UPDATE_DOB",
    UPDATE_EMAIL: "SAGA_ACTIONS/AUTH/UPDATE_EMAIL",
    CHECK_VALID_TOKEN: "SAGA_ACTIONS/AUTH/CHECK_VALID_TOKEN",
    SAVE_NOTIFICATION: "SAGA_ACTIONS/AUTH/SAVE_NOTIFICATION",
    CREATE_UPDATE_USER_GAME: "SAGA_ACTIONS/AUTH/CREATE_UPDATE_USER_GAME",
    REGISTRATION_FIELDS: "SAGA_ACTIONS/AUTH/REGISTRATION_FIELDS",
    DELETE_USER: "SAGA_ACTIONS/AUTH/DELETE_USER",
    SAVE_USER_PICKS: "SAGA_ACTIONS/AUTH/SAVE_USER_PICKS",
  },
  EVENT: {
    GROUPS: "SAGA_ACTIONS/EVENT/GROUPS",
    RODEO_EVENTS: "SAGA_ACTIONS/EVENT/RODEO_EVENTS",
    PAST_RODEO_EVENTS: "SAGA_ACTIONS/EVENT/PAST_RODEO_EVENTS",
    UPCOMING_EVENTS: "SAGA_ACTIONS/EVENT/UPCOMING_EVENTS",
    PERFORMANCES: "SAGA_ACTIONS/EVENT/PERFORMANCES",
    EVENTS: "SAGA_ACTIONS/EVENT/EVENTS",
    RODEO_EVENT_EVENTS: "SAGA_ACTIONS/EVENT/RODEO_EVENT_EVENTS",
    RODEO_EVENT_USER_PICK: "SAGA_ACTIONS/EVENT/RODEO_EVENT_USER_PICK",
    RODEO_EVENT_YOUR_PICKS: "SAGA_ACTIONS/EVENT/RODEO_EVENT_YOUR_PICKS",
    RIDERS: "SAGA_ACTIONS/EVENT/RIDERS",
    PICK_RIDER: "SAGA_ACTIONS/EVENT/PICK_RIDER",
    GAME_STATUS_TEXT: "SAGA_ACTIONS/EVENT/GAME_STATUS_TEXT",
    GET_RODEO_EVENT_GEO_LOCATIONS: "SAGA_ACTIONS/EVENT/GET_RODEO_EVENT_GEO_LOCATIONS",
    YOUR_PICKS: "SAGA_ACTIONS/EVENT/YOUR_PICKS",
    MY_TEAM: "SAGA_ACTIONS/EVENT/MY_TEAM",
    MY_CORRECT_PICKS: "SAGA_ACTIONS/EVENT/MY_CORRECT_PICKS",
    APPLY_LEAGUE_CODE: "SAGA_ACTIONS/EVENT/APPLY_LEAGUE_CODE",
    GET_SHARE_IMAGE_LINK: "SAGA_ACTIONS/EVENT/GET_SHARE_IMAGE_LINK",
    MOST_POPULAR_PICKS: "SAGA_ACTIONS/EVENT/MOST_POPULAR_PICKS",
    LEAGUE_LEADERBOARD: "SAGA_ACTIONS/EVENT/LEAGUE_LEADERBOARD",
    VS_LEAGUE_LEADERBOARD: "SAGA_ACTIONS/EVENT/VS_LEAGUE_LEADERBOARD",
    GROUP_LEADER_BOARD: "SAGA_ACTIONS/EVENT/GROUP_LEADER_BOARD",
    LEADERBOARD: "SAGA_ACTIONS/EVENT/LEADERBOARD",
    TV_IMAGE: "SAGA_ACTIONS/EVENT/TV_IMAGE",
    GROUP_TV_DETAILS: "SAGA_ACTIONS/TV_IMAGE/GROUP_TV_DETAILS",
    ACTIVE_PERFORMANCES: "SAGA_ACTIONS/EVENT/ACTIVE_PERFORMANCES",
    CATEGORIZED_PERFORMANCES: "SAGA_ACTIONS/EVENT/CATEGORIZED_PERFORMANCES",
    CATEGORIZED_RODEO_EVENTS: "SAGA_ACTIONS/EVENT/CATEGORIZED_RODEO_EVENTS",
    CATEGORIZED_EVENT_GROUPS: "SAGA_ACTIONS/EVENT/CATEGORIZED_EVENT_GROUPS",
    EVENT_GROUPS_LEADERBOARD: "SAGA_ACTIONS/EVENT/EVENT_GROUPS_LEADERBOARD",
    RODEO_LEADERBOARD: "SAGA_ACTIONS/EVENT/RODEO_LEADERBOARD",
    PERFORMANCE_LEADERBOARD: "SAGA_ACTIONS/EVENT/PERFORMANCE_LEADERBOARD",
    SIDEBAR_PERFORMANCE_LEADERBOARD: "SAGA_ACTIONS/EVENT/SIDEBAR_PERFORMANCE_LEADERBOARD",
    SIDEBAR_RODEO_LEADERBOARD: "SAGA_ACTIONS/EVENT/SIDEBAR_RODEO_LEADERBOARD",
    SIDEBAR_EVENT_GROUPS_LEADERBOARD: "SAGA_ACTIONS/EVENT/SIDEBAR_EVENT_GROUPS_LEADERBOARD",
    MY_PICK_LIST: "SAGA_ACTIONS/EVENT/MY_PICK_LIST",
    SAVE_COUPON: "SAGA_ACTIONS/EVENT/SAVE_COUPON",
    WINNING_TICKET_RESULTS: "SAGA_ACTIONS/EVENT/WINNING_TICKET_RESULTS",
  },
};

export * from "./site_statics";
export * from "./site_urls";
export * from "./functions";
export * from "./canvasUtils";
export * from "./card_utils";
